import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './Pages/Homepage';
import { useEffect } from 'react';
import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';
import { pdfjs } from 'react-pdf';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ResumeViewer from './Components/ResumeViewer'; // Ensure ResumeViewer is imported

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <MantineProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/resume" element={<Homepage showResumeModal={true} />} /> 
        </Routes>
      </Router>
    </MantineProvider>
  );
}

export default App;
